import Header from './modules/header.js';
import Fixed from './modules/fixed.js';
import Accordion from './modules/accordion.js';
import Slider from './modules/slider.js';
import Access from './modules/access.js';
import PageTab from './modules/page-tab.js';
import Remedy from './modules/remedy.js';
import Check from './pages/check.js';
import Skin from './pages/skin.js';

class App {
	constructor() {
		this.routes();
	}

	routes() {
		new Header();
		new Fixed();
		new Accordion();
		new Slider();
		new Access();
		new PageTab();
		new Remedy();
		new Check(); 
		new Skin(); 
	}

}

window.App = new App();
